export default {
  meta: {
    title: '客流计数'
  }
};
